import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../../Assets/Images/company_logo.png";
import "./videobanner.css";

const VideoBanner = ({
  videoUrl,
  heading,
  buttonText1,
  buttonLink1,
  buttonText2,
  buttonLink2,
  buttonText3,
  buttonLink3,
}) => {
  return (
    <div className="video-banner-bi">
      <div className="vb-content">
        {/* LEFT — VIDEO */}
        <div className="vb-video">
          <iframe
            src={videoUrl}
            title="Team Workout Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

        {/* RIGHT — LOGO + TITLE + BUTTON */}
        <div className="vb-right">
          <img src={Logo} alt="Company Logo" className="vb-logo" />

          <h2 className="vb-title">{heading}</h2>

          <div className="button-div">
            <Link to={buttonLink1} className="vb-btn">
              <span className="text-clip">{buttonText1}</span>
            </Link>
            <Link to={buttonLink2} className="vb-btn">
              <span className="text-clip">{buttonText2}</span>
            </Link>
            <Link to={buttonLink3} className="vb-btn">
              <span className="text-clip">{buttonText3}</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoBanner;
